<form #form="ngForm">
    <ng-container *ngIf="timeOffType">
        <app-time-off-type-card [timeOffType]="timeOffType" [isUpdate]="isUpdate"></app-time-off-type-card>

        <app-payroll-integration-selection-card [timeOffType]="timeOffType" [isPaid]="timeOffType.isPaid">
        </app-payroll-integration-selection-card>
    </ng-container>
</form>
